/* ==========================================================================
   SearcherFli > Client > Passenger
   ========================================================================== */

/* Modules */
const Input = require('@bluekiri/alexandria-contrib-components/components/input-rxjs/client/js');

const { fromEvent } = require('rxjs');
const { filter } = require('rxjs/operators');

const { addPanel } = require('./panel');

const { buildPassengersLabel } = require('./utils');

const { actions, types } = require('../store/actions');

const configuration = require('../config');

/* Init */
function initPassenger(instance) {
    const panel = instance;

    /* Actions */
    panel.actions = {
        ...instance.actions,
        changePassengers: payload => instance.store.dispatch(actions.changePassengers(payload))
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        changePassengers: instance.store.subscribe((state, action) => {
            if (action.type !== types.CHANGE_PASSENGERS) return;

            const { literals } = instance.config;

            panel.passengers.actions.setValue(buildPassengersLabel(literals, state.data.passengers));
        })
    };

    /* Selector */
    const { selector } = instance;

    /* Reference */
    panel.passengers = Input(
        `${selector} [data-component='InputRxjs'][data-type='${configuration().type.passengers}']`
    );

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        openPassengerPanel: fromEvent(instance.passengers.element, 'click')
            .pipe(filter(() => !instance.passengerPanel))
            .subscribe(() => {
                /* Add */
                addPanel(instance, instance.passengers.element);
            })
    };

    const { adults, children, babies } = instance.config.passengers;
    const value = {
        adults: adults.value,
        children: children.value,
        babies: babies.value
    };

    /* Sync */
    instance.actions.setSearcher({ passengers: value });
}

/* Destroy */
function destroyPassenger(instance) {
    const panel = instance;

    /* Reference */
    instance.passengers.actions.destroy();
    delete panel.passengers;

    /* Subscriptions */
    instance.subscriptions.openPassengerPanel.unsubscribe();
    delete panel.subscriptions.openPassengerPanel;
}

/* Exports */
module.exports = {
    initPassenger,
    destroyPassenger
};
